/**
 * Copy for the "At night" card. The clock settings screen has no i18n wiring (i18next is
 * not initialised), so — like the template catalogue — the language comes from the browser.
 */
const STRINGS = {
  en: {
    title: 'At night',
    toggle: 'Night screen on a schedule',
    off: 'Off',
    modeLabel: 'Mode',
    modes: {
      NIGHT_CLOCK: { name: 'Night clock', description: 'A dim red clock on black, with the next prayer' },
      SCREEN_OFF: { name: 'Screen off', description: 'A black screen with the backlight off' },
    },
    from: 'From',
    until: 'Until',
    clockTime: 'Clock time',
    prayerTime: 'Prayer',
    offset: 'Offset (min)',
    minutes: 'min',
    footer: 'On a schedule, or whenever Night mode is opened from Apps on the clock, the screen shows a dim red clock or goes black until the Until moment. Prayer times and the adhan keep working.',
    saved: 'Night settings saved',
    prayers: { Fajr: 'Fajr', Shuruq: 'Sunrise', Dhuhr: 'Dhuhr', Asr: 'Asr', Maghrib: 'Maghrib', Isha: 'Isha' },
  },
  nl: {
    title: "'s Nachts",
    toggle: 'Nachtscherm volgens schema',
    off: 'Uit',
    modeLabel: 'Weergave',
    modes: {
      NIGHT_CLOCK: { name: 'Nachtklok', description: 'Een gedimde rode klok op zwart, met het volgende gebed' },
      SCREEN_OFF: { name: 'Scherm uit', description: 'Een zwart scherm met de verlichting uit' },
    },
    from: 'Vanaf',
    until: 'Tot',
    clockTime: 'Kloktijd',
    prayerTime: 'Gebed',
    offset: 'Verschuiving (min)',
    minutes: 'min',
    footer: 'Volgens schema, of wanneer op de klok Nachtstand wordt geopend via Apps, toont het scherm een gedimde rode klok of gaat het zwart tot het Tot-moment. Gebedstijden en de adhan blijven werken.',
    saved: 'Nachtinstellingen opgeslagen',
    prayers: { Fajr: 'Fajr', Shuruq: 'Zonsopkomst', Dhuhr: 'Dhuhr', Asr: 'Asr', Maghrib: 'Maghrib', Isha: 'Isha' },
  },
  fr: {
    title: 'La nuit',
    toggle: 'Écran de nuit programmé',
    off: 'Désactivé',
    modeLabel: 'Affichage',
    modes: {
      NIGHT_CLOCK: { name: 'Horloge de nuit', description: 'Une horloge rouge tamisée sur fond noir, avec la prochaine prière' },
      SCREEN_OFF: { name: 'Écran éteint', description: 'Un écran noir, rétroéclairage éteint' },
    },
    from: 'À partir de',
    until: "Jusqu'à",
    clockTime: 'Heure fixe',
    prayerTime: 'Prière',
    offset: 'Décalage (min)',
    minutes: 'min',
    footer: "Selon le programme, ou dès que le mode Nuit est ouvert depuis Apps sur l'horloge, l'écran affiche une horloge rouge tamisée ou devient noir jusqu'au moment « Jusqu'à ». Les horaires de prière et l'adhan continuent de fonctionner.",
    saved: 'Réglages de nuit enregistrés',
    prayers: { Fajr: 'Fajr', Shuruq: 'Lever du soleil', Dhuhr: 'Dhuhr', Asr: 'Asr', Maghrib: 'Maghrib', Isha: 'Isha' },
  },
  es: {
    title: 'De noche',
    toggle: 'Pantalla nocturna programada',
    off: 'Desactivado',
    modeLabel: 'Modo',
    modes: {
      NIGHT_CLOCK: { name: 'Reloj nocturno', description: 'Un reloj rojo tenue sobre negro, con la próxima oración' },
      SCREEN_OFF: { name: 'Pantalla apagada', description: 'Una pantalla negra con la retroiluminación apagada' },
    },
    from: 'Desde',
    until: 'Hasta',
    clockTime: 'Hora fija',
    prayerTime: 'Oración',
    offset: 'Desfase (min)',
    minutes: 'min',
    footer: 'Según el horario, o cuando se abre el modo Noche desde Apps en el reloj, la pantalla muestra un reloj rojo tenue o se queda en negro hasta el momento «Hasta». Los horarios de oración y el adhan siguen funcionando.',
    saved: 'Ajustes nocturnos guardados',
    prayers: { Fajr: 'Fajr', Shuruq: 'Amanecer', Dhuhr: 'Dhuhr', Asr: 'Asr', Maghrib: 'Maghrib', Isha: 'Isha' },
  },
  ar: {
    title: 'ليلاً',
    toggle: 'شاشة ليلية حسب الجدول',
    off: 'متوقف',
    modeLabel: 'طريقة العرض',
    modes: {
      NIGHT_CLOCK: { name: 'ساعة ليلية', description: 'ساعة حمراء خافتة على خلفية سوداء، مع الصلاة القادمة' },
      SCREEN_OFF: { name: 'إطفاء الشاشة', description: 'شاشة سوداء مع إطفاء الإضاءة الخلفية' },
    },
    from: 'من',
    until: 'حتى',
    clockTime: 'وقت محدد',
    prayerTime: 'الصلاة',
    offset: 'الفارق (دقيقة)',
    minutes: 'د',
    footer: 'حسب الجدول، أو عند فتح الوضع الليلي من التطبيقات على الساعة، تعرض الشاشة ساعة حمراء خافتة أو تصبح سوداء حتى موعد «حتى». تستمر مواقيت الصلاة والأذان في العمل.',
    saved: 'تم حفظ الإعدادات الليلية',
    prayers: { Fajr: 'الفجر', Shuruq: 'الشروق', Dhuhr: 'الظهر', Asr: 'العصر', Maghrib: 'المغرب', Isha: 'العشاء' },
  },
  tr: {
    title: 'Geceleri',
    toggle: 'Zamanlanmış gece ekranı',
    off: 'Kapalı',
    modeLabel: 'Görünüm',
    modes: {
      NIGHT_CLOCK: { name: 'Gece saati', description: 'Siyah zemin üzerinde loş kırmızı bir saat ve sonraki vakit' },
      SCREEN_OFF: { name: 'Ekran kapalı', description: 'Arka ışığı kapalı, siyah bir ekran' },
    },
    from: 'Başlangıç',
    until: 'Bitiş',
    clockTime: 'Özel saat',
    prayerTime: 'Namaz vakti',
    offset: 'Fark (dk)',
    minutes: 'dk',
    footer: "Zamanlamaya göre ya da saatte Uygulamalar'dan Gece modu açıldığında, ekran Bitiş anına kadar loş kırmızı bir saat gösterir veya kararır. Namaz vakitleri ve ezan çalışmaya devam eder.",
    saved: 'Gece ayarları kaydedildi',
    prayers: { Fajr: 'İmsak', Shuruq: 'Güneş', Dhuhr: 'Öğle', Asr: 'İkindi', Maghrib: 'Akşam', Isha: 'Yatsı' },
  },
  de: {
    title: 'Nachts',
    toggle: 'Nachtbildschirm nach Zeitplan',
    off: 'Aus',
    modeLabel: 'Anzeige',
    modes: {
      NIGHT_CLOCK: { name: 'Nachtuhr', description: 'Eine gedimmte rote Uhr auf Schwarz, mit dem nächsten Gebet' },
      SCREEN_OFF: { name: 'Bildschirm aus', description: 'Ein schwarzer Bildschirm ohne Hintergrundbeleuchtung' },
    },
    from: 'Von',
    until: 'Bis',
    clockTime: 'Uhrzeit',
    prayerTime: 'Gebet',
    offset: 'Versatz (Min.)',
    minutes: 'Min.',
    footer: 'Nach Zeitplan oder immer wenn du auf der Uhr den Nachtmodus über Apps öffnest, zeigt der Bildschirm eine gedimmte rote Uhr oder wird schwarz – bis zur „Bis“-Zeit. Gebetszeiten und Adhan funktionieren weiterhin.',
    saved: 'Nachteinstellungen gespeichert',
    prayers: { Fajr: 'Fajr', Shuruq: 'Shuruq', Dhuhr: 'Dhuhr', Asr: 'Asr', Maghrib: 'Maghrib', Isha: 'Isha' },
  },
};

export const SCREEN_SCHEDULE_LANGUAGES = Object.keys(STRINGS);

export const screenScheduleStrings = (language) => {
  const lang = typeof language === 'string' ? language.slice(0, 2).toLowerCase() : 'en';
  return STRINGS[lang] || STRINGS.en;
};
